import { addSpacesAndCapitalize } from 'Helpers/Formats';

function getURLBreadcrumbs(eventName) {
  const crumbs = window.location.pathname
    .split('/')
    .map((pathPiece) => {
      switch (pathPiece) {
        case 'fre':
          return 'Tagging';
        case 'mission-control':
          return 'Mission Control';
        /* no default */
      }

      return addSpacesAndCapitalize(pathPiece);
    })
    .filter(v => v.length > 0);

  crumbs.push(eventName); // Append the event as the last element in the list

  return crumbs.join(' > ');
}

export default getURLBreadcrumbs;
